import styles from '../styles/eventCard.module.scss'; 

// @ts-ignore
const EventCard = ({children, onClick}) => {
  return (
    <div className={styles.card} onClick={onClick}>{children}</div>
  )
}

export default EventCard